import React, { useEffect } from 'react'
import DatePicker from 'react-datepicker'
import Select from 'react-select'
import { Button } from 'reactstrap'
import getRoleList from '@/service/getRoles'
import { labelizeNamedData } from '@/shared/helpers'
import getUserStatusList from '@/service/getUserStatuses'
import { fetchEventTypes } from '@/shared/apiHelper'
import 'react-datepicker/dist/react-datepicker.css'

const BulkReclaimFilterForm = ({ onClickFilterCallback, filter, organization, program }) => {
    const [keyword, setKeyword] = React.useState('')
    const [role, setRole] = React.useState('')
    const [selectedRole, setSelectedRole] = React.useState(null)
    const [roleOptions, setRoleOptions] = React.useState([])
    const [statusOptions, setStatusOptions] = React.useState([])
    const [status, setStatus] = React.useState(null)
    const [from, setFrom] = React.useState(null)
    const [to, setTo] = React.useState(null)
    const [awardType, setAwardType] = React.useState(null)
    const [awardTypeOptions, setAwardTypeOptions] = React.useState([])
    const [awarder, setAwarder] = React.useState('')
    const [awardee, setAwardee] = React.useState('')

    useEffect(() => {
        if (organization?.id) {
            getRoleList(organization.id).then(list => {
                setRoleOptions([
                    { value: '', label: 'All' },
                    ...labelizeNamedData(list.data),
                ])
            })
            getUserStatusList(organization.id).then(list => {
                setStatusOptions([
                    { value: '', label: 'All' },
                    ...labelizeNamedData(list, ['status', 'status']),
                ])
            })
        }
    }, [organization])

    useEffect(() => {
        if (organization?.id && program?.id) {
            fetchEventTypes(organization.id, program.id).then(types => {
                setAwardTypeOptions([
                    { value: '', label: 'All' },
                    ...labelizeNamedData(types),
                ])
            })
        }
    }, [organization, program])

    useEffect(() => {
        setKeyword(filter?.keyword || '')
        setRole(filter?.role_id || '')
        setAwarder(filter?.awarder || '')
        setAwardee(filter?.awardee || '')
        setFrom(filter?.from || null)
        setTo(filter?.to || null)
    }, [filter])

    const onClickFilter = (e) => {
        e.preventDefault()
        onClickFilterCallback({
            keyword,
            role_id: role,
            status: status?.value || '',
            from: from || '',
            to: to || '',
            award_type: awardType?.value || '',
            awarder,
            awardee,
        })
    }

    const resetFilter = (e) => {
        e.preventDefault()
        setKeyword('')
        setRole('')
        setSelectedRole(null)
        setStatus(null)
        setFrom(null)
        setTo(null)
        setAwardType(null)
        setAwarder('')
        setAwardee('')
        onClickFilterCallback({
            keyword: '',
            role_id: '',
            status: '',
            from: '',
            to: '',
            award_type: '',
            awarder: '',
            awardee: '',
        })
    }

    return (
        <form onSubmit={onClickFilter} className="form">
            {/* Row 1: user search filters */}
            <div className="row mb-2 align-items-center">
                <div className="col-md-9">
                    <div className="row mb-2">
                        <div className="col-md-4">
                            <p className="mb-1">Search Users</p>
                            <input
                                value={keyword}
                                onChange={(e) => setKeyword(e.target.value)}
                                type="text"
                                className="form-control"
                                placeholder="Search by ID, email, name, Employee ID."
                            />
                        </div>
                        <div className="col-md-2">
                            <p className="mb-1">Role</p>
                            <Select
                                value={selectedRole}
                                onChange={(opt) => { setSelectedRole(opt); setRole(opt.value) }}
                                options={roleOptions}
                                className="react-select"
                                placeholder="All"
                                classNamePrefix="react-select"
                            />
                        </div>
                        <div className="col-md-3">
                            <p className="mb-1">Status</p>
                            <Select
                                value={status}
                                onChange={setStatus}
                                options={statusOptions}
                                className="react-select"
                                placeholder="All"
                                classNamePrefix="react-select"
                            />
                        </div>
                        <div className="col-md-3">
                            <p className="mb-1">Award Type</p>
                            <Select
                                value={awardType}
                                onChange={setAwardType}
                                options={awardTypeOptions}
                                className="react-select"
                                placeholder="All"
                                classNamePrefix="react-select"
                                isClearable
                            />
                        </div>
                    </div>
                    {/* Row 2: award-specific filters */}
                    <div className="row mb-2">
                        <div className="col-md-3">
                            <p className="mb-1">Award Date From</p>
                            <DatePicker
                                selected={from}
                                onChange={setFrom}
                                dateFormat="yyyy-MM-dd"
                                placeholderText="From date"
                                className="form-control"
                                isClearable
                            />
                        </div>
                        <div className="col-md-3">
                            <p className="mb-1">Award Date To</p>
                            <DatePicker
                                selected={to}
                                onChange={setTo}
                                dateFormat="yyyy-MM-dd"
                                placeholderText="To date"
                                className="form-control"
                                isClearable
                            />
                        </div>
                        
                        <div className="col-md-3">
                            <p className="mb-1">Awarder</p>
                            <input
                                value={awarder}
                                onChange={(e) => setAwarder(e.target.value)}
                                type="text"
                                className="form-control"
                                placeholder="Name or email"
                            />
                        </div>
                        <div className="col-md-3">
                            <p className="mb-1">Awardee</p>
                            <input
                                value={awardee}
                                onChange={(e) => setAwardee(e.target.value)}
                                type="text"
                                className="form-control"
                                placeholder="Name or email"
                            />
                        </div>
                    </div>
                </div>
                <div className="col-md-3 d-flex align-items-end">
                    <Button type="submit" className="btn btn-sm btn-primary mr-2 mb-0">
                        Filter
                    </Button>
                    <Button type="button" className="btn btn-sm btn-secondary mb-0" onClick={resetFilter}>
                        Reset
                    </Button>
                </div>
            </div>
        </form>
    )
}

export default BulkReclaimFilterForm
